import styled from 'styled-components';

export const StyledGrid = styled.div`
  margin: .125rem;  
  display: grid;
  grid-template-columns: repeat(3, 33%);
  justify-content: space-evenly;
  border: .125rem solid #1e1e1e;
  border-radius: .5rem;
  background: #1e1e1e;
`;